// extracted by mini-css-extract-plugin
export default {"facet":"facet--nYbbL","facet__checkbox":"facet__checkbox--v7haM","facet__name":"facet__name--BWlKY","facet__checkbox--checked":"facet__checkbox--checked--vClfk"};